


<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ isEditing ? "Editing Additional Observation List" : "Adding Additional Observation List" | translate | async }}<!--  {{ title }} -->
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">

    <div>
        <mat-form-field class="input">
          <input class="titleInput" matInput placeholder="{{'Additional Observations' | translate | async}}" type="text" [(ngModel)]="additionalObservationList.Title" [formControl]="descriptionControl"
        ngDefaultControl required>
        </mat-form-field>
        <div *ngIf="descriptionControl.errors && (descriptionControl.dirty || descriptionControl.touched)" style="margin-bottom: 20px;">
          <mat-error *ngIf="descriptionControl.errors.required">{{'An Observation Description is required'| translate | async}}</mat-error>
        </div>
    </div>

    <div *ngIf="showEnable">
      <mat-form-field class="input">
        <mat-select placeholder="{{'Status' | translate | async}}" [(ngModel)]="additionalObservationList.Disabled" ngDefaultControl required>
          <mat-option [value]="true"> {{ 'Disable' | translate | async }}  </mat-option>
          <mat-option [value]="false">  {{ 'Enable' | translate | async }}  </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field class="action-input" *ngIf="createfromObsList==true">
      <mat-select  placeholder="{{'Select Answer Type' | translate | async}}" [(ngModel)]="additionalObservationList.QuestionTypeId">

        <mat-option *ngFor="let _type of data.QuestionTypes" [value]="_type.Id">
          {{_type.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
    <button mat-raised-button color="warn" [disabled]="descriptionControl.errors" [class.loading]="saving" (click)="save()"><span class="material-icons button__icon">check</span><span class="button__text">{{ 'Save Observation List' | translate | async }} </span></button>
  </div>
</div>
